import { FeatureCollection, Point } from 'geojson';
import { v4 as uuid } from 'uuid';
import { IGetMeasure, IRiverResponse, IWorkingAreaResponse } from '../apis/apiSlice';
import { parseFromWK } from 'wkt-parser-helper';
import { Feature } from 'geojson';

export interface IPoint {
  id?: number | string;
  x: number;
  y: number;
}

export const createPoint = (measure: IGetMeasure) => {
  return parseFromWK(measure.geometry) as Point;
}

export const createPointFeatureCollection = (measures: Array<IGetMeasure>) => {
  if (measures && measures.length > 0){
      const features = measures.map((p: IGetMeasure) => {     
      const featureId = p.id ? p.id : uuid();
      return {
        type: "Feature",
        id: featureId,
        properties:{
          id: featureId
        },        
        geometry: p.point
      }}
    )
    const geojson = {
      type: "FeatureCollection",
      features: features
    }
    return geojson as FeatureCollection<any, any>
  } 
}

export const getPolygonFeatureCollection = (items: Array<IWorkingAreaResponse>) => {
  const features = Array<Feature<any>>();
  items.forEach(item => {
    const geometry = item.geometry;
    const MULTIPOLYGON = "MULTIPOLYGON";
    const POLYGON = "POLYGON";
    if (geometry && (geometry.includes(MULTIPOLYGON) || geometry.includes(POLYGON))){
      const geojsonGeometry = parseFromWK(geometry)
      
      const feature = {
        type: "Feature",
        id: item.id,
        properties: {		
          id: item.id,		
          name: item.sourceTableName           
        },
        geometry: geojsonGeometry            
    } as any
    features.push(feature)  
  }});       
  
    const fc = {
    type: "FeatureCollection",
    name: "areas",
    crs: {
      type: "name",
      properties: {
        name: "urn:ogc:def:crs:EPSG::25832"
      }
    },
    features
  } as any
  return fc;
}

export const getPolylineFeatureCollection = (items: Array<IRiverResponse>) => {
  const features = Array<Feature<any>>();
  items.forEach(item => {
    const geometry = item.geometry;
    const MULTILINESTRING = "MULTILINESTRING";
    const LINESTRING = "LINESTRING";
    if (geometry && (geometry.includes(MULTILINESTRING) || geometry.includes(LINESTRING))){
      const geojsonGeometry = parseFromWK(geometry)
      
      const feature = {
        type: "Feature",
        id: item.id,
        properties: {		
          id: item.id,		
          name: item.name           
        },
        geometry: geojsonGeometry            
    } as any
    features.push(feature)  
  }});       
  
    const fc = {
    type: "FeatureCollection",
    name: "rivers",
    crs: {
      type: "name",
      properties: {
        name: "urn:ogc:def:crs:EPSG::25832"
      }
    },
    features
  } as any
  return fc;
}